import * as motionElements from 'motion/react-m';
import { AnimatePresence } from 'motion/react';

/**
 * Animation, loaded on demand.
 *
 * `motion.div` pulls the whole animation engine into the entry bundle.
 * `motion/react-m` ships only the element proxies — a few kilobytes — and the
 * DOM feature set is fetched after first paint by the LazyMotion provider in
 * Providers.jsx. The difference is roughly 30 KB gzipped, which is a sixth of
 * the storefront's entire entry budget.
 *
 * Every animated element imports `m` from here rather than reaching for
 * `motion/react` directly, so one stray import cannot undo the split.
 */

export const loadMotionFeatures = () => import('motion/react').then((module) => module.domAnimation);

export const m = motionElements;
export { AnimatePresence };
